/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ProblemTooManyRequests } from './ProblemTooManyRequests';

export const TooManyRequestsProblems: core.serialization.Schema<
    serializers.TooManyRequestsProblems.Raw,
    Truvity.TooManyRequestsProblems
> = core.serialization
    .union('type', {
        '/too-many-requests': ProblemTooManyRequests,
    })
    .transform<Truvity.TooManyRequestsProblems>({
        transform: (value) => value,
        untransform: (value) => value,
    });

export declare namespace TooManyRequestsProblems {
    export type Raw = TooManyRequestsProblems.TooManyRequests;

    export interface TooManyRequests extends ProblemTooManyRequests.Raw {
        type: '/too-many-requests';
    }
}
